// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hq-0";